module.exports = new __parcel__URL__("waves.7798a008.svg").toString();